import CampaignTemplateCreatePage from "./CampaignTemplateCreatePage";

export default CampaignTemplateCreatePage;
